import { GetStaticProps } from "next";
import { getAllPosts, type PostMeta } from "~/lib/mdx";
import {
  buildDefaultSolutionsSections,
  createSolutionsPage,
} from "~/components/solutions/solutionsPageFactory";
import { SolutionsForRealEstateContent as content } from "~/content/dla-biur-nieruchomosci/content.pl";
import InfoLinks from "~/components/InfoLinks";

const selectedId = [141, 142, 143, 144, 145];

const sections = buildDefaultSolutionsSections(content, <InfoLinks />);

export default createSolutionsPage({
  content,
  faqSelectedIds: selectedId,
  sections,
});

export const getStaticProps: GetStaticProps<{ recentPosts: PostMeta[] }> = async () => {
  const recentPosts = getAllPosts().slice(0, 3);
  return { props: { recentPosts } };
};
